var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCashierinline = function SvgCashierinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 71,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A98F",
    d: "M56.448 35.854v13.549H14.112V46.58h4.516v-7.197c0-2.823 1.552-5.222 3.81-6.492l3.387 3.387 3.387-3.387c2.258 1.27 3.81 3.67 3.81 6.492v7.197h4.375c.141-3.105 2.681-5.504 5.786-5.504h.423v-5.222h3.246v-3.387H44.17v-4.94h7.338v4.94h-3.246v3.387h8.185ZM29.636 27.245c0 1.976-1.694 3.67-3.67 3.67s-3.669-1.694-3.669-3.67c0-1.975 1.694-3.669 3.67-3.669 1.975 0 3.669 1.553 3.669 3.67Z"
  })));
};
export default SvgCashierinline;